/**
 * Clear all NextAuth-related cookies from the browser.
 *
 * Removes stale PKCE / CSRF / state cookies that can accumulate
 * after crashed or interrupted OAuth flows, preventing the next
 * sign-in attempt from hanging.
 */
export function clearAuthCookies() {
  document.cookie.split(";").forEach((c) => {
    const name = c.split("=")[0].trim();
    if (
      name.startsWith("next-auth.") ||
      name.startsWith("__Secure-next-auth.") ||
      name.startsWith("__Host-next-auth.")
    ) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    }
  });
}
